export default __webpack_public_path__ + "static/media/heart.0b47a16a.svg";